import { useNavigate } from "react-router-dom";

import { Button } from "../Button/Button";
import { Section } from "../Section/Section";
import "./ErrorFallback.scss";
import { Title } from "../../components/Title/Title";

interface Props {
  error: Error;
  resetErrorBoundary: () => void;
}

export const ErrorFallback = ({ resetErrorBoundary, error }: Props) => {
  const navigate = useNavigate();

  return (
    <Section size="md">
      <div className="error-fallback">
        <div className="error-fallback__message">
          <Title text="Error" suffix="Ocurred" />
          <div>
            Dear user We have caught an unexpected error. Are you connected to
            the right network?
          </div>

          <Button
            variant="PRIMARY"
            className="error-fallback__button"
            fullWidth
            onClick={() => {
              navigate("/");
              resetErrorBoundary();
            }}
          >
            Take me from here!
          </Button>
        </div>
      </div>
    </Section>
  );
};
